import React from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../../common/routes/app_routes";
import { Text } from "../../../../../components/common/typography";

type LoginSharedActionsProps = {
  isPasswordLogin: boolean;
};

export const LoginSharedActions: React.FC<LoginSharedActionsProps> = ({
  isPasswordLogin,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex w-full items-center justify-center">
      <Text variant="body" tone="muted" inline>
        New to Procurtal?{" "}
        <button
          type="button"
          onClick={() =>
            navigate(
              isPasswordLogin
                ? AppRoutes.CREATE_ACCOUNT
                : `${AppRoutes.CREATE_ACCOUNT}?method=phone`,
            )
          }
          className="bg-transparent"
        >
          <Text variant="bodyBold" tone="dark" inline>
            Sign up
          </Text>
        </button>
      </Text>
    </div>
  );
};

export default LoginSharedActions;
